(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Theme
//
// ------------------------------------

(function ($) {

	if (typeof window.Theme == 'undefined') window.Theme = {};

	Theme = {

		settings: {},

		/*
		 * Theme init
		 */

		init: function () {


			// Share
			// this.share();

			// Header Carousel
			this.carouselHeader();

			// Announcments
			this.annoucements();

			// Header Video
			this.headerVideo();

			// Social Feeds
			// this.social();

			// Messenger
			this.messenger();

			// Custom  Location Menu
			this.mosaicLocationMenu();

			// Cookie Policy
			this.cookiePolicy();

		},

		messenger: function () {

			if ($('[data-messenger]').length <= 0) return;
			$('footer.default').addClass('-has-messenger');

		},

		// ------------------------------------
		// Header Video
		// ------------------------------------

		headerVideo: function () {

			// Original Removed Video From All Touch Devices
			// if($('.touch').length > 0) {
			// 	$('header iframe').remove();
			// 	$('.header-video').remove();
			// }

			// New Let's Admin Decide
			if ($('.touch .hide-video-mobile').length > 0) {
				$('header iframe').remove();
				$('.header-video').remove();
			} else {
				// Hide Youtube Videos
				if ($('.touch header iframe').length > 0) {
					let src = $('header iframe').attr('src');
					if (src.indexOf('youtube') > -1) {
						$('header iframe').remove();
						$('.header-video').remove();
					}
				}

			}

		},

		// ------------------------------------
		// Announcments
		// ------------------------------------

		annoucements: function () {

			$('.announcement-controls span').on('click', function (e) {

				$('.announcement').removeClass('open');
				var id = $('.announcement').data('announcementId');

				Util.setCookie('announcement_seen_' + id, true);

			});

			// Show Announcement
			var id = $('.announcement').data('announcementId');
			if (!Util.getCookie('announcement_seen_' + id)) $('.announcement').addClass('open');

		},

		// ------------------------------------
		// Share JS
		// ------------------------------------

		share: function () {

			// Setup

			$("a[data-share]").share({
				counts: false
			});

		},

		// ------------------------------------
		// Social
		// ------------------------------------

		social: function () {

			$('[data-social="instagram"]').socialFeed({
				// callbackSuccess:Theme.instagramFeed,

			});

		},

		// ------------------------------------
		// Instagram Feed
		// ------------------------------------

		instagramFeed: function (data) {

			// alert("Instgram Feed Callback");
			console.log(data);
			$element.addClass('-success');

		},

		// ------------------------------------
		// Carousel Header
		// ------------------------------------

		// Carousel Header
		carouselHeader: function () {

			// Simple Carousel
			if ($('.header-carousel').length <= 0) return;

			var active = 1;
			var $items = $('.header-carousel-image');

			setInterval(function () {

				$('.header-carousel-image').removeClass('active');
				$('.header-carousel-image').eq(active).addClass('active');
				active++;

				if (active >= $items.length) active = 0;

			}, 5000);

		},

		mosaicLocationMenu: function () {

			$('.location-menu > a').html('<span class="text">Locations</span><span class="line"></span>');
			$('.location-menu').addClass('-loaded');
		},

		cookiePolicy: function () {

			// Guard
			if (Util.getCookie('cookie_policy_accepted')) return;

			// Display Banner
			$('.cookie-policy-banner').addClass('-active');

			// Add Clock
			$('.cookie-policy-banner .close').on('click', function (e) {
				e.preventDefault();
				$('.cookie-policy-banner').removeClass('-active');
				Util.setCookie('cookie_policy_accepted', true, 365);
			})

		}

	};

	module.exports = Theme;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/theme.js","/modules")